import styled from "styled-components"

export const FormInputsServiceProviderWrapper = styled.div`
	border-bottom: 1px solid #eaeafd;
	padding-bottom: 24px;
	.containerCheckBox {
		> p {
			margin: 0;
			padding: 0;
			font-weight: 400;
			font-size: 14px;
			line-height: 100%;
			letter-spacing: 0%;
			color: #8e98a1;
		}
		.conatinerCheckbox {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 25px;
			.itemCheckbox {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				color: #261b6a;
				font-weight: 400;
				font-size: 12px;
			}
		}
	}
`
